(function (ws) {
    'use strict';
    /**
     * @typedef {Object} Event - event object
     * @typedef {Object} Array - array object
     */
    ws.views.quoteSalesOffice = ws.views.googleAnalytics.extend({

        /**
         * Initialize override.
         */
        initialize: function() {
            this.$salesOffice = $('[name="salesOffice"]');

            this.eventAgg.on('salesOfficeValidation', this.salesOfficeValidation, this);
            this.eventAgg.on('focusSalesOfficeField', this.focusSalesOfficeField, this);
            this.updateSalesOffice();
        },

        events: {
            'change .sales-org': 'updateSalesOffice'
        },

        updateSalesOffice: function() {
            var selectedVal = this.$('.sales-org :selected').attr('value');
            if (selectedVal) {
                this.$salesOffice.val(selectedVal);
            } else {
                var selectedSalesOffice = this.$salesOffice.val();
                this.$('.sales-org').val(selectedSalesOffice);
            }

        },

        /**
         * Show error msg and highlight the sales office dropdown
         */
        salesOfficeValidation: function() {
            this.$('#salesOffice').addClass('error');
            this.$('.required-error-message').show();
        },

        focusSalesOfficeField: function() {
            $('html, body').animate({
                scrollTop: $('.required-error-message:visible:first').offset().top - 200
            }, 700);
        }
    });
})(westcon);
